<template>
	<a-modal dialogClass="login-dialog" :footer="null" :closable="false" :visible="visible" @cancel="handleClose">
		<div class="line"></div>
		<div class="main">
			<div class="title">
				<div></div>
				<div class="text">登录</div>
				<div></div>
			</div>
			<!-- <div class="tabs">
				<div class="tab" :class="{ active: index == activeTab }" v-for="(tab, index) in tabs" :key="index"
					@click="handleTab(index)">
					<a-icon :type="tab.type" theme="filled"
						:style="[{ fontSize: '14px' }, { marginRight: '6px' }, { color: index == activeTab ? '#fff' : '#333' }]" />
					{{ tab.label }}
				</div>
			</div> -->
			<div class="content">
				<template v-if="!activeTab">
					<div class="tip">微信扫码登录</div>
					<div class="ewm">
						<!-- <img src="../assets/images/ewm.png"> -->
					</div>
				</template>
				<template v-else>
					<div class="form">
						<a-form-model ref="ruleForm" layout="vertical" :model="ruleForm" :rules="rules">
							<a-form-model-item ref="phone" label="手机号" prop="phone">
								<a-input v-model="ruleForm.phone" addon-before="+86" placeholder="请输入手机号" />
							</a-form-model-item>
							<a-form-model-item ref="code" label="验证码" prop="code">
								<a-input-search v-model="ruleForm.code" placeholder="4位数字验证码" @search="handleCode">
									<a-button slot="enterButton" style="width: 120px;">
										{{ codeText }}
									</a-button>
								</a-input-search>
							</a-form-model-item>
						</a-form-model>
					</div>
					<div class="btn" @click="handleLogin">
						登录
					</div>
				</template>
				<div class="agree">未注册用户登录后将自动创建账户</div>
				<div class="agree">登录即表示同意<span>用户协议</span>和<span>隐私政策</span></div>
			</div>
		</div>
	</a-modal>
</template>
<script>
import { getCodeApi } from '@/api/login'
import { mapActions } from "vuex"

export default {
	name: 'LoginDialog',
	data() {
		return {
			visible: false,
			tabs: [{
				label: '微信扫码',
				type: 'wechat'
			}, {
				label: '手机验证码',
				type: 'phone'
			}],
			activeTab: 1,
			ruleForm: {
				phone: '',
				code: ''
			},
			rules: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ len: 11, message: '请输入11位手机号', trigger: 'blur' },
				],
				code: [
					// { required: true, message: '请输入验证码', trigger: 'blur' },
					{ len: 4, message: '请输入4位验证码', trigger: 'blur' },
				],
			},
			codeText: '获取验证码',
			codeCount: 0,
		}
	},
	methods: {
		...mapActions(["Login", "Logout", "GetInfo"]),
		// 弹窗 打开
		handleOpen() {
			this.visible = true
		},
		// 弹窗 关闭
		handleClose() {
			this.visible = false
		},
		// Tab 切换
		handleTab(index) {
			this.activeTab = index
		},
		// 获取验证码
		async handleCode() {
			if (this.codeCount > 0) {
				this.$message.error(`${this.codeCount}s后再试`)
				return
			}
			this.$refs.ruleForm.validateField('phone', async valid => {
				if (!valid) {
					const res = await getCodeApi({
						phone: this.ruleForm.phone,
					})
					if (res.code == 0) {
						this.handleCodeCountDown()
					} else {
						this.$message.error('获取验证码失败')
					}
				}
			})
		},
		// 获取验证码倒计时
		handleCodeCountDown() {
			this.codeCount = 60
			this.codeText = '60s后重新获取'
			const timer = setInterval(() => {
				if (this.codeCount > 0) {
					this.codeCount -= 1
					this.codeText = `${this.codeCount}s后重新获取`
				} else {
					this.codeText = '获取验证码'
					clearInterval(timer)
				}
			}, 1000)
		},
		// 登录
		handleLogin() {
			const {
				Login,
				Logout,
				GetInfo
			} = this
			this.$refs.ruleForm.validate(async valid => {
				if (valid) {
					Login(this.ruleForm)
						.then(() => {
							this.$message.success('登录成功')
							GetInfo().then(() => {
								// console.log('获取用户信息成功')
							}).catch(() => {
								Logout.then(() => {
									// console.log('获取用户信息失败')
								})
							})
						})
						.catch(() => {
							this.$message.error('登录失败')
						})
						.finally(() => {
							this.$emit('list')
							this.handleClose()
						})
				} else {
					return false
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped>
:deep .login-dialog {

	.ant-modal-content {
		border-radius: 0;
	}

	.ant-modal-body {
		padding: 0;


		.line {
			width: 100%;
			height: 4px;
			background: linear-gradient(90deg, #7845ff, #ff4372);
		}

		.main {
			padding: 10px 30px 30px;
			background-image: url('../assets/images/card-bg.png');
			background-color: #fff;
			background-position: top left;
			background-repeat: no-repeat;
			background-size: contain;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 10px 0 30px;

				.text {
					font-size: 24px;
					font-weight: bolder;
					line-height: 1;
					color: #333333;
				}
			}

			.tabs {
				display: flex;
				justify-content: space-between;
				align-items: center;
				background-color: #fff;
				border-radius: 26px;
				box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);

				.tab {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
					height: 40px;
					border-radius: 26px;
					font-size: 14px;
					cursor: pointer;
				}

				.active {
					color: #fff;
					background-color: #5B66FF;
				}
			}

			.content {
				margin-top: 30px;

				.tip {
					margin-bottom: 20px;
					font-size: 16px;
					font-weight: bolder;
					color: #313131;
					text-align: center;
				}

				.ewm {
					text-align: center;
					margin-bottom: 50px;
				}

				.btn {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 0 0 20px 0;
					width: 100%;
					height: 40px;
					background: #5B66FF;
					border-radius: 5px;
					font-size: 14px;
					color: #fff;
					cursor: pointer;
				}

				.agree {
					text-align: center;
					font-size: 12px;
					color: #999;

					span {
						color: #5B66FF;
					}
				}
			}
		}
	}
}
</style>
